export default __webpack_public_path__ + "static/video1-61b1d779d9ce1407c8a96f3f8e6447b6.jpg";